import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';
import { buildParamsFromObject } from '@/app/common/utils/http/http';
import { PaginatedResponse } from '@/app/common/utils/pagination/types';
import { VehicleFineService } from '../core/service';
import {
  FineStatusEnum,
  VehicleFine,
  VehicleFineCreateParams,
  VehicleFineFindAllParams,
  VehicleFineSummary,
  VehicleFineSummaryParams,
  VehicleFineUpdateParams,
} from '../core/type';

@Injectable()
export class VehicleFineApiService implements VehicleFineService {
  private readonly baseUrl = `${environment.apiHost}/fines`;

  constructor(private http: HttpClient) {}

  findAll(
    filter?: VehicleFineFindAllParams,
  ): Observable<PaginatedResponse<VehicleFine>> {
    return this.http.get<PaginatedResponse<VehicleFine>>(this.baseUrl, {
      params: buildParamsFromObject(filter),
    });
  }

  getSummary(
    params?: VehicleFineSummaryParams,
  ): Observable<VehicleFineSummary> {
    return this.http.get<VehicleFineSummary>(`${this.baseUrl}/summary`, {
      params: buildParamsFromObject(params),
    });
  }

  create(params: VehicleFineCreateParams): Observable<VehicleFine> {
    return this.http.post<VehicleFine>(this.baseUrl, params);
  }

  update(
    id: number,
    params: VehicleFineUpdateParams,
  ): Observable<VehicleFine> {
    return this.http.patch<VehicleFine>(`${this.baseUrl}/${id}`, params);
  }

  updateStatus(id: number, status: FineStatusEnum): Observable<VehicleFine> {
    return this.http.patch<VehicleFine>(`${this.baseUrl}/${id}/status`, {
      status,
    });
  }

  remove(id: number): Observable<{ id: number }> {
    return this.http.delete<{ id: number }>(`${this.baseUrl}/${id}`);
  }
}
